import { Injectable } from '@angular/core';
import { ResponseAPI } from '@models/response';
import { BaseService } from '@services/base.service';
import { CartModel } from './n15.model';
import { ProductModel } from '@modules/admin/pages/n06/n06.model';
import { OrderModel } from '@modules/admin/pages/n07/n07.model';

@Injectable({
  providedIn: 'root'
})
export class N15Service extends BaseService {
  constructor() {
    super();
  }

  getCart() {
    return this.httpClient.get<ResponseAPI<CartModel>>('/N15');
  }

  getAddItem(product) {
    return this.httpClient.post<ResponseAPI<{}>>('/N15', product);
  }

  getChangeItem(product) {
    return this.httpClient.put<ResponseAPI<{}>>('/N15/change', product);
  }

  getDeleteItem(idProduct: number) {
    return this.httpClient.delete<ResponseAPI<{}>>(`/N15/${idProduct}`);
  }

  getCreateOrder(data) {
    return this.httpClient.post<ResponseAPI<OrderModel>>(`/N10/orders/user`, data);
  }
  getUpdateOrder(id, data) {
    return this.httpClient.put<ResponseAPI<OrderModel>>(`/N10/orders/evidence/${id}`, data);
  }
}
